var React = require('react');

function Close (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m9.016 40.837c.195.195.451.292.707.292s.512-.098.708-.293l14.292-14.309 14.292 14.309c.195.196.451.293.708.293.256 0 .512-.098.707-.292.391-.39.391-1.023.001-1.414l-14.278-14.294 14.277-14.293c.39-.391.39-1.024-.001-1.414-.392-.391-1.024-.391-1.414.001l-14.293 14.309-14.292-14.309c-.391-.391-1.024-.391-1.414-.001-.391.39-.391 1.023-.001 1.414l14.276 14.293-14.276 14.294c-.39.39-.39 1.024.001 1.414z"}));
}

Close.defaultProps = {"enableBackground":"new 0 0 50 50","viewBox":"0 0 50 50"};

module.exports = Close;

Close.default = Close;
